// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prz-blk h1,.prz-blk h2{font-style:normal;font-weight:600;font-size:1.125rem;line-height:1.6875rem;color:#333;margin-top:2.25rem;margin-bottom:.75rem}.prz-blk h1.title-align-center,.prz-blk h1.title-align-right,.prz-blk h2.title-align-center,.prz-blk h2.title-align-right{margin-right:1rem;margin-left:1rem}.prz-blk h1.title-align-right,.prz-blk h2.title-align-right{text-align:right}.prz-blk h1.title-align-center,.prz-blk h2.title-align-center{text-align:center}.prz-blk h1.title-align-justify,.prz-blk h2.title-align-justify{text-align:justify}.prz-blk.prz-blk-child{width:100%;margin:0}.prz-blk.prz-blk-child>.prz-grd-row,.prz-blk.prz-blk-child>.prz-mob-grd-row{margin:0}.prz-blk.prz-blk-no-title{padding-top:2rem}", ""]);
// Exports
exports.locals = {
	"blue-green-9_5": "#093c2a",
	"blue-green-9": "#11523a",
	"blue-green-8_5": "#1a674b",
	"blue-green-8": "#227c5b",
	"blue-green-7": "#32a77d",
	"blue-green-6": "#43d19e",
	"blue-green": "#53fcbf",
	"blue-green-4": "#75fdcc",
	"blue-green-3": "#98fdd9",
	"blue-green-2": "#bafee5",
	"blue-green-1_5": "#cbfeec",
	"blue-green-1": "#ddfef2",
	"blue-green-0_5": "#eefff9",
	"yellow-9_5": "#3c3709",
	"yellow-9": "#524b11",
	"yellow-8_5": "#675f1a",
	"yellow-8": "#7c7322",
	"yellow-7": "#a79b32",
	"yellow-6": "#d1c343",
	"yellow": "#fceb53",
	"yellow-4": "#fdef75",
	"yellow-3": "#fdf398",
	"yellow-2": "#fef7ba",
	"yellow-1_5": "#fef9cb",
	"yellow-1": "#fefbdd",
	"yellow-0_5": "#fffdee",
	"pink-9_5": "#11090f",
	"pink-9": "#23111f",
	"pink-8_5": "#341a2e",
	"pink-8": "#45223e",
	"pink-7": "#68335c",
	"pink-6": "#8a447b",
	"pink": "#ad559a",
	"pink-4": "#bd77ae",
	"pink-3": "#ce99c2",
	"pink-2": "#debbd7",
	"pink-1_5": "#e6cce1",
	"pink-1": "#efddeb",
	"pink-0_5": "#f7eef5",
	"dark-purple-9_5": "#090810",
	"dark-purple-9": "#0e0c17",
	"dark-purple-8_5": "#12101f",
	"dark-purple-8": "#1c192f",
	"dark-purple-7": "#25213e",
	"dark-purple-6": "#2e294e",
	"dark-purple": "#4c476b",
	"dark-purple-4": "#6a6688",
	"dark-purple-3": "#8984a4",
	"dark-purple-2": "#9893b3",
	"dark-purple-1_5": "#a7a3c1",
	"dark-purple-1": "#b6b2d0",
	"dark-purple-0_5": "#c5c1de",
	"purple-9_5": "#0b0911",
	"purple-9": "#171123",
	"purple-8_5": "#221a34",
	"purple-8": "#2d2245",
	"purple-7": "#443368",
	"purple-6": "#5a448a",
	"purple": "#7155ad",
	"purple-4": "#8d77bd",
	"purple-3": "#aa99ce",
	"purple-2": "#c6bbde",
	"purple-1_5": "#d4cce6",
	"purple-1": "#e3ddef",
	"purple-0_5": "#f1eef7",
	"dark-blue-9_5": "#03090a",
	"dark-blue-9": "#071114",
	"dark-blue-8_5": "#0a1a1f",
	"dark-blue-8": "#0e2229",
	"dark-blue-7": "#14333d",
	"dark-blue-6": "#1b4452",
	"dark-blue": "#256",
	"dark-blue-4": "#427181",
	"dark-blue-3": "#638d9b",
	"dark-blue-2": "#83aab6",
	"dark-blue-1_5": "#93b8c3",
	"dark-blue-1": "#a4c6d0",
	"dark-blue-0_5": "#b4d4de",
	"blue-9_5": "#041112",
	"blue-9": "#082224",
	"blue-8_5": "#0c3436",
	"blue-8": "#104548",
	"blue-7": "#18676d",
	"blue-6": "#208a91",
	"blue": "#28acb5",
	"blue-4": "#53bdc4",
	"blue-3": "#7ecdd3",
	"blue-2": "#a9dee1",
	"blue-1_5": "#bee6e9",
	"blue-1": "#d4eef0",
	"blue-0_5": "#e9f7f8",
	"aqua-9_5": "#030f0e",
	"aqua-9": "#051f1c",
	"aqua-8_5": "#082e2a",
	"aqua-8": "#0b3d38",
	"aqua-7": "#105c53",
	"aqua-6": "#167a6f",
	"aqua": "#1b998b",
	"aqua-4": "#43aca1",
	"aqua-3": "#6bc0b6",
	"aqua-2": "#92d3cc",
	"aqua-1_5": "#a6ddd7",
	"aqua-1": "#bae7e1",
	"aqua-0_5": "#cef0ec",
	"green-9_5": "#15280f",
	"green-9": "#223c18",
	"green-8_5": "#2e5022",
	"green-8": "#3a642b",
	"green-7": "#538b3f",
	"green-6": "#6bb352",
	"green": "#84db65",
	"green-4": "#9de284",
	"green-3": "#b5e9a3",
	"green-2": "#cef1c1",
	"green-1_5": "#daf4d1",
	"green-1": "#e6f8e0",
	"green-0_5": "#f3fbf0",
	"yellow-green-9_5": "#0f1205",
	"yellow-green-9": "#1f2309",
	"yellow-green-8_5": "#2e350e",
	"yellow-green-8": "#3d4713",
	"yellow-green-7": "#5c6a1c",
	"yellow-green-6": "#7a8e26",
	"yellow-green": "#99b12f",
	"yellow-green-4": "#adc159",
	"yellow-green-3": "#c2d082",
	"yellow-green-2": "#d6e0ac",
	"yellow-green-1_5": "#e0e8c1",
	"yellow-green-1": "#ebefd5",
	"yellow-green-0_5": "#f5f7ea",
	"light-orange-9_5": "#3c2709",
	"light-orange-9": "#523711",
	"light-orange-8_5": "#67471a",
	"light-orange-8": "#7c5722",
	"light-orange-7": "#a77832",
	"light-orange-6": "#d19843",
	"light-orange": "#fcb853",
	"light-orange-4": "#fdc675",
	"light-orange-3": "#fdd498",
	"light-orange-2": "#fee3ba",
	"light-orange-1_5": "#feeacb",
	"light-orange-1": "#fef1dd",
	"light-orange-0_5": "#fff8ee",
	"orange-9_5": "#1a0b05",
	"orange-9": "#32140b",
	"orange-8_5": "#4b1e10",
	"orange-8": "#632716",
	"orange-7": "#933a20",
	"orange-6": "#c44d2b",
	"orange": "#f46036",
	"orange-4": "#f6805e",
	"orange-3": "#f8a086",
	"orange-2": "#fbbfaf",
	"orange-1_5": "#fccfc3",
	"orange-1": "#fddfd7",
	"orange-0_5": "#feefeb",
	"red-9_5": "#160406",
	"red-9": "#2b080c",
	"red-8_5": "#410b12",
	"red-8": "#560f18",
	"red-7": "#811725",
	"red-6": "#ac1e31",
	"red": "#d7263d",
	"red-4": "#df5164",
	"red-3": "#e77d8b",
	"red-2": "#efa8b1",
	"red-1_5": "#f3bec5",
	"red-1": "#f7d4d8",
	"red-0_5": "#fbe9ec",
	"black": "#333",
	"white": "#fff",
	"silver": "#ddd",
	"grey": "#f8f8f8",
	"bgClassName": "prz-bbit-bgcolor-",
	"colorClassName": "prz-bbit-color-",
	"borderClassName": "prz-bbit-border-"
};
module.exports = exports;
